<!-- StepBar.vue -->
<template>
  <div class="stepbar-container rounded-1">
    <div class="container-fluid">
      <div class="row align-items-center">
        <div v-for="(step, index) in steps" :key="index" class="col step-col">
          <div 
            class="step-item"
            @click="navigateToStep(index)"
            :class="{ 'cursor-pointer': true }"
          >
            <!-- Step Circle -->
            <div 
              class="step-circle d-flex align-items-center justify-content-center mx-auto"
              :class="[
                'border-2',
                currentStep > index ? 'bg-success border-success' : 
                currentStep === index ? 'bg-theme border-theme' : 
                'bg-light border-secondary'
              ]"
            >
              <span 
                class="fw-bold"
                :class="[
                  currentStep > index ? 'text-white' : 
                  currentStep === index ? 'text-white' : 
                  'text-secondary'
                ]"
              >
                <i v-if="currentStep > index" class="bi bi-check-lg"></i>
                <span v-else>{{ index + 1 }}</span>
              </span>
            </div>

            <!-- Step Label -->
            <div 
              class="step-label text-center mt-2 fw-500 user-select-none"
              :class="[
                currentStep > index ? 'text-success' : 
                currentStep === index ? 'text-theme' : 
                'text-secondary'
              ]"
            >
              {{ step }}
            </div>
          </div>

          <!-- Progress Line (between steps) -->
          <div 
            v-if="index < steps.length - 1"
            class="step-line"
            :class="[
              currentStep > index ? 'bg-success' : 'bg-secondary'
            ]"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      default: () => ['Customer', 'Services', 'Attachments', 'Summary']
    }
  },
  data() {
    return {
      currentStep: 0
    };
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const scrollPosition = window.scrollY + 250;

      for (let i = this.steps.length - 1; i >= 0; i--) {
        const section = document.querySelector(`[data-section="${i}"]`);
        if (section && section.offsetTop <= scrollPosition) {
          this.currentStep = i;
          break;
        }
      }
    },
    navigateToStep(stepIndex) {
      const section = document.querySelector(`[data-section="${stepIndex}"]`);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        this.currentStep = stepIndex;
      }
    }
  }
};
</script>

<style scoped>
.stepbar-container {
  position: sticky;
  top: 60px;
  background: white;
  padding: 10px 0;
  z-index: 100;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  margin-bottom: 10px;
}

.step-col {
  display: flex;
  align-items: center;
  position: relative;
  flex: 1;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.step-item:hover {
  transform: scale(1.05);
}

.step-circle {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  min-width: 25px;
  min-height: 25px;
  transition: all 0.3s ease;
  font-size: 11px;
  position: relative;
  z-index: 2;
}

.step-circle:hover {
  box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
  transform: scale(1.1);
}

.step-label {
  font-size: 13px;
  font-weight: 500;
  white-space: nowrap;
  transition: color 0.3s ease;
}

.step-item:hover .step-label {
  color: var(--bs-primary) !important;
}

/* Progress Line */
.step-line {
  position: absolute;
  height: 3px;
  top: 12px;
  left: 50%;
  right: -50%;
  transition: background-color 0.3s ease;
  z-index: 0;
}

/* Responsive */
@media (max-width: 768px) {
  .stepbar-container {
    padding: 15px 0;
  }

  .step-circle {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    font-size: 10px;
  }

  .step-label {
    font-size: 11px;
    margin-top: 8px;
  }

  .step-line {
    height: 2px;
    top: 10px;
  }
}

@media (max-width: 576px) {
  .step-circle {
    width: 20px;
    height: 20px;
    min-width: 20px;
    min-height: 20px;
    font-size: 10px;
  }

  .step-label {
    font-size: 9px;
  }
}
</style>